import { useEffect, useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Megaphone } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

/** Render text with **bold** segments and preserve newlines. */
const renderFormatted = (text: string) => {
  const lines = text.split("\n");
  return lines.map((line, li) => {
    const parts = line.split(/(\*\*[^*]+\*\*)/g).filter(Boolean);
    return (
      <Fragment key={li}>
        {parts.map((part, pi) =>
          part.startsWith("**") && part.endsWith("**") ? (
            <strong key={pi} className="font-bold">
              {part.slice(2, -2)}
            </strong>
          ) : (
            <Fragment key={pi}>{part}</Fragment>
          ),
        )}
        {li < lines.length - 1 && <br />}
      </Fragment>
    );
  });
};

export const InfoBanner = () => {
  const { i18n } = useTranslation();
  const [enabled, setEnabled] = useState(false);
  const [textCs, setTextCs] = useState("");
  const [textEn, setTextEn] = useState("");

  useEffect(() => {
    (async () => {
      const { data } = await supabase
        .from("app_settings")
        .select("key,value")
        .in("key", ["info_banner_enabled", "info_banner_text_cs", "info_banner_text_en"]);
      const map = new Map((data ?? []).map((r: any) => [r.key, r.value]));
      setEnabled(map.get("info_banner_enabled") === "true");
      setTextCs(map.get("info_banner_text_cs") ?? "");
      setTextEn(map.get("info_banner_text_en") ?? "");
    })();
  }, []);

  const isEn = (i18n.language ?? "").toLowerCase().startsWith("en");
  const text = (isEn ? textEn : textCs).trim() || (isEn ? textCs : textEn).trim();

  if (!enabled || !text) return null;

  return (
    <div className="relative mb-5 overflow-hidden rounded-2xl border-2 border-primary/40 bg-gradient-to-br from-primary/15 via-primary/5 to-accent/10 p-4 shadow-elevated">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-12 -top-12 h-40 w-40 rounded-full bg-primary/20 blur-3xl"
      />
      <div className="relative flex items-start gap-3">
        <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-primary text-primary-foreground shadow-md">
          <Megaphone className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="mb-1 text-[11px] font-bold uppercase tracking-widest text-primary">
            {isEn ? "Announcement" : "Oznámení"}
          </p>
          <div className="text-sm leading-relaxed text-foreground">{renderFormatted(text)}</div>
        </div>
      </div>
    </div>
  );
};
